import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../shared/atoms/Box';
import EmptyState from '../../shared/molecules/EmptyState';
import MessageThreadCard from './MessageThreadCard';

/**
 * FIXERLIGHT-049 — la liste « Mes messages », dans l'ORDRE EXACT rendu par
 * l'api (`GET /clients/{client}/message-threads`, contrat § 2 :
 * `last_message_at DESC`, le plus récent en tête). Jamais de retri ici,
 * même doctrine que `WorkshopBookingsList` (FIXERLIGHT-052).
 */
const MessageThreadsList = ({ threads }) => {
  const { t } = useTranslation();

  if (!threads || !threads.length) {
    return (
      <Box alignItems="center" data-testid="message-threads-empty">
        <EmptyState
          width="60%"
          title={t('messages.empty.title')}
          subTitle={t('messages.empty.subtitle')}
        />
      </Box>
    );
  }

  return (
    <Box data-testid="message-threads-list">
      {threads.map((thread) => (
        <MessageThreadCard key={thread.id} thread={thread} />
      ))}
    </Box>
  );
};

export default MessageThreadsList;
